<template>
    <div>
        <div class="col-md-12">
        <div class="form-group input-container" :class="{ 'input-error': JSON.parse(errors).username ? true : false }">
            <label>Email:</label>
            <div class="input-box">
                <i class="icon email-icon"></i>
                <input 
                    type="text" 
                    autocomplete="none"
                    id="recover-password-email"
                    class="form-control"
                    @focus="disablePhone()"
                    @blur="enablePhone()"
                    v-model="email"
                >
            </div>
            <span v-if="JSON.parse(errors).username" class="text-danger error">{{ JSON.parse(errors).username[0] }}</span>
        </div>
    </div>
    <div class="divider"><span>ou</span></div>
    <div
        class="input-container" :class="{ 'input-error': JSON.parse(errors).phonecode || JSON.parse(errors).phone ? true : false }">
        <label>Telefone :</label>
        <div>
            <phone-mask id="recover-password-phone"
                :disabledphone="hidePhone"
            ></phone-mask>
        </div>

        <span v-if="JSON.parse(errors).phonecode" class="text-danger error">{{ JSON.parse(errors).phonecode[0] }}</span>
        <span v-else-if="JSON.parse(errors).phone" class="text-danger error">{{ JSON.parse(errors).phone[0] }}</span>
    </div>
</div>
 
</template>

<script>
import debounce from 'lodash.debounce';
export default {
    data() {
        return {
            hidePhone: false,
            email: null
        }
    },
    props: {
        errors: {
            required: false,
        }
    },
    methods:{
        disablePhone(){
            this.hidePhone = true
        },
        enablePhone(){
            if(this.email == null || this.email.length == 0){
                this.hidePhone = false
            }
        },
    },
    watch: {
        email: debounce(function (email) {
            //when updateEmailInfo is triggered, b/e cleans updatePhoneInfo
            Livewire.emit('updateEmailInfo', email);
        }, 400)
    }

}
</script>

<style>

</style>